import Slider, { type SliderProps } from '@mui/material/Slider';

export default function MySlider(props: SliderProps) {
  return (
    <Slider
      {...props}
      sx={{
        width: 150,
        height: 6,
        '& .MuiSlider-thumb': {
          width: 14,
          height: 14,
          backgroundColor: 'white',
          borderColor: 'var(--color-primary)',
          borderWidth: 3,
        },
        '& .MuiSlider-track': {
          backgroundColor:
            props.track === 'inverted'
              ? 'var(--color-gainsboroGray)'
              : 'var(--color-primary)',
          border: 'none',
        },
        '& .MuiSlider-rail': {
          color:
            props.track === 'inverted'
              ? 'var(--color-primary)'
              : 'var(--color-gainsboroGray)',
          opacity: 1,
        },
        '& .MuiSlider-valueLabel': {
          backgroundColor: 'var(--color-gainsboroGray)',
          color: 'black',
          fontSize: 12,
          paddingX: 0.4,
          paddingY: 0.2,
        },
        '& .MuiSlider-mark': {
          opacity: 0,
        },
        '& .MuiSlider-markLabel': {
          color: 'black',
          fontSize: 10,
        },
        ...props.sx,
      }}
    />
  );
}
